export const zIndex = {
  auto: "auto",
  hide: -1,
  base: 0,
  inputFocus: 2,
  tabs: 2,
  button: 2,
  modal: 1000,
  drawer: 1001,
  notification: 1002,
  message: 1003,
  table: 1,
}
